<template>
  <b-list-group-item>
    {{optitem.name}}
    <a style="float: right;"  :href="'#'+$route.path">
      <b-icon icon="x-circle" variant="danger" font-scale="1.5" v-b-popover.hover.right="'Remove Choice from Option'" @click="removeOptionOptItem"></b-icon>
    </a>
  </b-list-group-item>
</template>
<script>
export default {
  name: 'OptionOptItems',
  props: ['optitem', 'option_id'],
  data () {
    return {

    }
  },

  methods: {
    emitRefreshOptionItems() {
      this.$emit('emit-refresh-optionitems');
    },

    emitSwitchOverlay(bool) {
      this.$emit('emit-switch-overlay', bool);
    },

    async removeOptionOptItem() {
      this.emitSwitchOverlay(true);
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      var config = {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      };
      // update order with status of 'ready'
      const { data } = await this.$api.delete('optionheaders/'+this.option_id+'/optionitems/'+this.optitem.id,
        config
      );
      if (data.deleted == true) {
        this.emitRefreshOptionItems();
      } else {
        this.emitSwitchOverlay(false);
        this.$bvModal.msgBoxOk('There was a problem removing the choice from the option, please try again later.', {
          title: 'Error removing choice',
          centered: true
        })
      }
    },

  },
}
</script>

<style>
</style>
